import React, { useEffect, useRef, useState } from "react";
import SideNav from "./components/side-nav/SideNav";
import BreadCrumb from "./components/bread-crumb/BreadCrumb";
import styles from "./layout.module.scss";
import CompleteProfile from "./components/complete-profile";
import NotificationCenter from "./components/Notification-center/NotificationCenter";
import { useSelector } from "react-redux";
import ErrorBoundary from "./components/ErrorBoundary";

const Layout = ({
  children,
  crumbs = [],
  title,
  subtitle,
  SideNavSection,
  toggle = true,
  overlap = false,
  hideScrollbar = false,
}) => {
  const [isPanelCollapsed, setIsCollapsed] = useState(false);
  const [showNotificationCenter, setShowNotificationCenter] = useState(false);
  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        showNotificationCenter &&
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotificationCenter(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showNotificationCenter]);

  return (
    <>
      <div className={styles.container}>
        <div
          className={`${styles.panel} ${isPanelCollapsed ? styles["panel-collapsed"] : styles["panel--expanded"]}`}
        >
          <div
            className={styles.button}
            onClick={() => setIsCollapsed(!isPanelCollapsed)}
          >
            <i className="pi pi-angle-left" style={{ color: "white" }} />
          </div>
          <ErrorBoundary>
            <SideNav
              isPanelCollapsed={isPanelCollapsed}
              setShowNotificationCenter={setShowNotificationCenter}
            />
          </ErrorBoundary>

          {showNotificationCenter && (
            <div
              ref={notificationRef}
              className={styles["notification-wrapper"]}
            >
              <ErrorBoundary>
                <NotificationCenter
                  setShowNotificationCenter={setShowNotificationCenter}
                />
              </ErrorBoundary>
            </div>
          )}
        </div>
        <div
          className={`${styles.content} ${hideScrollbar && styles["content-details-view"]} ${isPanelCollapsed ? styles["panel-collapsed"] : styles["panel--expanded"]}`}
        >
          <ErrorBoundary>
            <BreadCrumb crumbs={crumbs} />
          </ErrorBoundary>
          {title && <p className="general-info mb-3">{title}</p>}
          {subtitle && <p className="general-info-paragraph">{subtitle}</p>}
          <ErrorBoundary>{children}</ErrorBoundary>
        </div>
        <ErrorBoundary>
          <CompleteProfile />
        </ErrorBoundary>
        {!overlap && SideNavSection && toggle && (
          <div className={styles["sidenav-section"]}>
            {" "}
            <ErrorBoundary>
              <SideNavSection />{" "}
            </ErrorBoundary>
          </div>
        )}
      </div>

      {overlap && SideNavSection && toggle && (
        <div className={styles["sidenav-section-overlap"]}>
          {" "}
          <ErrorBoundary>
            <SideNavSection />{" "}
          </ErrorBoundary>
        </div>
      )}
    </>
  );
};

export default Layout;
